import types from "./actionTypes";
import { dealWithInstances } from '../../undoredo/actions';


export const addInstance = (payload, noUndoRedo) => (dispatch) => {

	if (noUndoRedo != true)
		dispatch(dealWithInstances(payload, 'add'))

	dispatch({
		type: types.ADD_INSTANCE,
		payload,
	})
};

export const editInstance = (payload, noUndoRedo) => (dispatch) => {

	if (noUndoRedo != true)
		dispatch(dealWithInstances(payload, 'edit'))

	dispatch({
		type: types.EDIT_INSTANCE,
		payload,
	})
};


export const deleteInstance = (payload, noUndoRedo) => (dispatch) => {

	if (noUndoRedo != true)
		dispatch(dealWithInstances(payload, 'delete'))

	dispatch({
		type: types.DELETE_INSTANCE,
		payload,
	})
};

// export const editInstance = (payload) => ({
// 	type: types.EDIT_INSTANCE,
// 	payload,
// });

// export const deleteInstance = (payload) => ({
// 	type: types.DELETE_INSTANCE,
// 	payload,
// });

export const updateFullInstances = (instances) => ({
	type: types.UPDATE_FULL_INSTANCES,
	payload: instances
})

export const resetInstances = (instances) => ({
	type: types.RESET_INSTANCES,
	payload: instances
})